var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import {
    isMillisecondsAccepted,
    isUrlAccepted,
    Milliseconds,
    Url
} from '@ef-carbon/primitive';
import Tracks from '../Tracks';
import { assign } from './assign';
import { register } from './factory';
import Type from './Type';
import trackFactory from '../track/factory';
function isIOptions(init) {
    return init !== null && typeof init === 'object' && !isUrlAccepted(init);
}
function options(init) {
    return isIOptions(init) ? init : { url: init };
}
export class Generic {
    constructor(init) {
        this.type = Type.Audio;
        this.duration = undefined;
        const _a = options(init), {url, start, end, tracks, duration, copy} = _a, rest = __rest(_a, [
                'url',
                'start',
                'end',
                'tracks',
                'duration',
                'copy'
            ]);
        this.url = new Url(url);
        this.start = new Milliseconds(isMillisecondsAccepted(start) ? start : 0, { min: 0 });
        this.end = new Milliseconds(isMillisecondsAccepted(end) ? end : Infinity, { min: 0 });
        if (+this.end !== Infinity && +this.end < +this.start) {
            const swap = this.start;
            this.start = this.end;
            this.end = swap;
        }
        this.array = tracks ? Array.from(tracks, trackFactory) : [];
        this.proxy = new Tracks(this.array);
        if (duration !== undefined) {
            if (!isMillisecondsAccepted(duration) || duration === Infinity || duration < 0) {
                throw new TypeError(`Invalid duration (${ duration }) value for '${ this.url }' audio`);
            }
            this.duration = new Milliseconds(duration);
        }
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.url.configurable = false;
        descriptors.start.configurable = false;
        descriptors.end.configurable = false;
        descriptors.proxy.configurable = false;
        descriptors.proxy.enumerable = false;
        descriptors.array.configurable = false;
        descriptors.array.enumerable = false;
        descriptors.tracks = {
            enumerable: true,
            get: () => this.array,
            set: value => {
                this.array = Array.from(value);
                this.proxy = new Tracks(this.array);
            }
        };
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
    get track() {
        return this.proxy;
    }
}
export class Audio extends Generic {
}
export const klass = Audio;
export default Audio;
register(Type.Audio, Audio);    //# sourceMappingURL=Audio.js.map
